// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  padding: 10px 40px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.navbar-container {
  max-width: 1200px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navbar-logo img {
  height: 60px;
}

/* ===== Default Desktop Links ===== */
.navbar-links {
  display: flex;
  gap: 30px;
  list-style: none;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.navbar-links a {
  text-decoration: none;
  color: black;
  transition: color 0.3s ease;
}

.navbar-links a:hover {
  color: #2b7de9;
}

/* ===== Contact Button ===== */
.navbar-contact .contact-button {
  background-color: #003528;
  color: white;
  padding: 12px 30px;
  border-radius: 9999px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.navbar-contact .contact-button:hover {
  background-color: #005541;
}

/* ===== Hamburger Icon ===== */
.menu-icon {
  display: none;
  cursor: pointer;
  flex-direction: column;
  gap: 5px;
}

.bar {
  width: 28px;
  height: 3px;
  background-color: #003528;
  border-radius: 5px;
  transition: 0.4s;
}

/* Animation for open state */
.bar1.open {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.bar2.open {
  opacity: 0;
}

.bar3.open {
  transform: rotate(45deg) translate(-5px, -6px);
}

/* ===== Mobile Styles ===== */
@media (max-width: 900px) {
  .menu-icon {
    display: flex;
  }

  .navbar-links {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    background-color: white;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 25px 0;
    transform: translateY(-120%);
    transition: transform 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 999;
  }

  .navbar-links.active {
    transform: translateY(0);
  }

  .navbar-links li {
    width: 100%;
    text-align: center;
  }

  .navbar-links a {
    display: block;
    width: 100%;
    padding: 10px 0;
    color: #003528;
    font-size: 1.1rem;
  }

  .navbar-links a:hover {
    color: #007a5a;
  }

  .navbar-contact {
    display: none;
  }

  .mobile-contact {
    display: block;
  }
}

/* ===== Extra Small Screens ===== */
@media (max-width: 480px) {
  .navbar {
    padding: 8px 20px;
  }

  .navbar-logo img {
    height: 50px;
  }

  .navbar-links a {
    font-size: 1rem;
  }
}

/* ===== Mobile Styles ===== */
@media (max-width: 900px) {
  .menu-icon {
    display: flex;
  }

  .navbar-links {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    background-color: white;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 25px 0;
    transform: translateY(-120%);
    transition: transform 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 999;
  }

  .navbar-links.active {
    transform: translateY(0);
  }

  .navbar-links li {
    width: 100%;
    text-align: center;
  }

  .navbar-links a {
    display: block;
    width: 100%;
    padding: 10px 0;
    color: #003528;
    font-size: 1.1rem;
  }

  .navbar-links a:hover {
    color: #007a5a;
  }

  /* Hide desktop contact */
  .navbar-contact {
    display: none;
  }

  /* Show contact link inside menu on mobile only */
  .mobile-contact {
    display: block;
  }
}

/* ===== Desktop & Tablet Default ===== */
@media (min-width: 901px) {
  /* Hide mobile menu contact link */
  .mobile-contact {
    display: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA,yBAAyB;EACzB;IACE,aAAa;EACf;;EAEA,iDAAiD;EACjD;IACE,cAAc;EAChB;AACF;;AAEA,yCAAyC;AACzC;EACE,kCAAkC;EAClC;IACE,aAAa;EACf;AACF","sourcesContent":[".navbar {\n  padding: 10px 40px;\n  background-color: white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.navbar-container {\n  max-width: 1200px;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-logo img {\n  height: 60px;\n}\n\n/* ===== Default Desktop Links ===== */\n.navbar-links {\n  display: flex;\n  gap: 30px;\n  list-style: none;\n  font-weight: 500;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.navbar-links a {\n  text-decoration: none;\n  color: black;\n  transition: color 0.3s ease;\n}\n\n.navbar-links a:hover {\n  color: #2b7de9;\n}\n\n/* ===== Contact Button ===== */\n.navbar-contact .contact-button {\n  background-color: #003528;\n  color: white;\n  padding: 12px 30px;\n  border-radius: 9999px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: background-color 0.3s ease;\n}\n\n.navbar-contact .contact-button:hover {\n  background-color: #005541;\n}\n\n/* ===== Hamburger Icon ===== */\n.menu-icon {\n  display: none;\n  cursor: pointer;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.bar {\n  width: 28px;\n  height: 3px;\n  background-color: #003528;\n  border-radius: 5px;\n  transition: 0.4s;\n}\n\n/* Animation for open state */\n.bar1.open {\n  transform: rotate(-45deg) translate(-5px, 6px);\n}\n\n.bar2.open {\n  opacity: 0;\n}\n\n.bar3.open {\n  transform: rotate(45deg) translate(-5px, -6px);\n}\n\n/* ===== Mobile Styles ===== */\n@media (max-width: 900px) {\n  .menu-icon {\n    display: flex;\n  }\n\n  .navbar-links {\n    position: absolute;\n    top: 80px;\n    left: 0;\n    width: 100%;\n    background-color: white;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    padding: 25px 0;\n    transform: translateY(-120%);\n    transition: transform 0.3s ease;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    z-index: 999;\n  }\n\n  .navbar-links.active {\n    transform: translateY(0);\n  }\n\n  .navbar-links li {\n    width: 100%;\n    text-align: center;\n  }\n\n  .navbar-links a {\n    display: block;\n    width: 100%;\n    padding: 10px 0;\n    color: #003528;\n    font-size: 1.1rem;\n  }\n\n  .navbar-links a:hover {\n    color: #007a5a;\n  }\n\n  .navbar-contact {\n    display: none;\n  }\n\n  .mobile-contact {\n    display: block;\n  }\n}\n\n/* ===== Extra Small Screens ===== */\n@media (max-width: 480px) {\n  .navbar {\n    padding: 8px 20px;\n  }\n\n  .navbar-logo img {\n    height: 50px;\n  }\n\n  .navbar-links a {\n    font-size: 1rem;\n  }\n}\n\n/* ===== Mobile Styles ===== */\n@media (max-width: 900px) {\n  .menu-icon {\n    display: flex;\n  }\n\n  .navbar-links {\n    position: absolute;\n    top: 80px;\n    left: 0;\n    width: 100%;\n    background-color: white;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    padding: 25px 0;\n    transform: translateY(-120%);\n    transition: transform 0.3s ease;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    z-index: 999;\n  }\n\n  .navbar-links.active {\n    transform: translateY(0);\n  }\n\n  .navbar-links li {\n    width: 100%;\n    text-align: center;\n  }\n\n  .navbar-links a {\n    display: block;\n    width: 100%;\n    padding: 10px 0;\n    color: #003528;\n    font-size: 1.1rem;\n  }\n\n  .navbar-links a:hover {\n    color: #007a5a;\n  }\n\n  /* Hide desktop contact */\n  .navbar-contact {\n    display: none;\n  }\n\n  /* Show contact link inside menu on mobile only */\n  .mobile-contact {\n    display: block;\n  }\n}\n\n/* ===== Desktop & Tablet Default ===== */\n@media (min-width: 901px) {\n  /* Hide mobile menu contact link */\n  .mobile-contact {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
